import {
  BankOutlined,
  ClusterOutlined,
  CreditCardOutlined,
  DeploymentUnitOutlined,
  DollarOutlined,
  FileSearchOutlined,
  IssuesCloseOutlined,
  LineChartOutlined,
  LoginOutlined,
  LogoutOutlined,
  NotificationOutlined,
  RetweetOutlined,
  SolutionOutlined,
  StopOutlined,
  SwapOutlined,
  TeamOutlined,
  UserOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import { Badge, Layout, Menu } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { Urls } from '#constants';

import logoSmall from './logo_small.png';

import classes from './styles.module.scss';

const { Sider } = Layout;

export const Sidebar = ({ collapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const userRole = useSelector((state) => state.userData.user.role);
  const isAdmin = userRole === 'admin';
  const incomeCount = useSelector((state) => state.incomesPage?.countNew);
  const outcomeCount = useSelector((state) => state.outcomesPage?.countNew);

  const getItem = useCallback(
    (label, key, icon, children, type) => ({
      children,
      icon,
      key,
      label,
      type
    }),
    []
  );

  const selectedKey = useMemo(() => {
    const urls = Object.values(Urls).slice(1);

    return (
      urls.findIndex((el) => {
        return location.pathname.includes(el);
      }) + 1 || 1
    );
  }, [location]);

  console.log(selectedKey);
  return (
    <Sider collapsed={collapsed} collapsible trigger={null}>
      <NavLink to={Urls.OutcomePage}>
        <div className={classes.logo}>
          <img src={logoSmall} />
        </div>
      </NavLink>

      <Menu
        defaultOpenKeys={[]}
        items={[
          getItem(
            <NavLink to={Urls.OutcomePage}>
              {t('Payouts')}
              <Badge
                count={outcomeCount}
                offset={[10, -2]}
                size={'small'}
                style={{ backgroundColor: '#faad14', color: '#000' }}
              />
            </NavLink>,
            '1',
            <LogoutOutlined />
          ),
          getItem(
            <NavLink to={Urls.IncomePage}>
              {t('Receipts')}
              <Badge
                count={incomeCount}
                offset={[10, -2]}
                size={'small'}
                style={{ backgroundColor: '#faad14', color: '#000' }}
              />
            </NavLink>,
            '2',
            <LoginOutlined />
          ),
          isAdmin && [
            getItem(
              <NavLink to={Urls.UsersPage}>{t('Users')}</NavLink>,
              '3',
              <TeamOutlined />
            )
          ],
          getItem(
            <NavLink to={Urls.Clients}>{t('Clients')}</NavLink>,
            '4',
            <UserOutlined />
          ),
          isAdmin && [
            getItem(
              <NavLink to={Urls.Traders}>{t('Traders')}</NavLink>,
              '5',
              <UserOutlined />
            )
          ],
          isAdmin && [
            getItem(
              <NavLink to={Urls.Operators}>{t('Operators')}</NavLink>,
              '6',
              <UserSwitchOutlined />
            )
          ],
          getItem(
            <NavLink to={Urls.Cards}>{t('Cards')}</NavLink>,
            '7',
            <CreditCardOutlined />
          ),
          getItem(
            <NavLink to={Urls.Tariffs}>{t('Tariffs')}</NavLink>,
            '8',
            <DollarOutlined />
          ),
          getItem(
            <NavLink to={Urls.Banks}>{t('Banks')}</NavLink>,
            '9',
            <BankOutlined />
          ),
          getItem(
            <NavLink to={Urls.Devices}>{t('Devices')}</NavLink>,
            '10',
            <DeploymentUnitOutlined />
          ),
          isAdmin && [
            getItem(
              <NavLink to={Urls.Holders}>{t('Holders')}</NavLink>,
              '11',
              <SolutionOutlined />
            )
          ],
          isAdmin && [
            getItem(
              <NavLink to={Urls.Agents}>{t('Agents')}</NavLink>,
              '12',
              <ClusterOutlined />
            )
          ],
          getItem(
            <NavLink to={Urls.Notifications}>{t('Notifications')}</NavLink>,
            '13',
            <NotificationOutlined />
          ),
          getItem(
            <NavLink to={Urls.Corrections}>{t('Balance corrections')}</NavLink>,
            '14',
            <RetweetOutlined />
          ),
          getItem(
            <NavLink to={Urls.Debtors}>{t('Debtors')}</NavLink>,
            '15',
            <IssuesCloseOutlined />
          ),
          {
            children: [
              getItem(
                <NavLink to={Urls.GreyList}>{t('Temporary')}</NavLink>, // временный + постоянный
                '16'
              ),
              getItem(
                <NavLink to={Urls.BlackList}>{t('Permanent')}</NavLink>, // временный + постоянный
                '17'
              )
            ],
            icon: <StopOutlined />,
            key: 'SubMenu',
            label: 'Black list'
          },

          getItem(
            <NavLink to={Urls.Transactions}>{t('Transactions')}</NavLink>,
            '18',
            <SwapOutlined />
          ),
          isAdmin && [
            getItem(
              <NavLink to={Urls.Statistic}>{t('Statistics')}</NavLink>,
              '19',
              <LineChartOutlined />
            )
          ],
          isAdmin && [
            getItem(
              <NavLink to={Urls.CardStatement}>{t('Card statement')}</NavLink>,
              '20',
              <LineChartOutlined />
            )
          ],
          isAdmin && [
            getItem(
              <NavLink to={Urls.Settings}>{t('Settings')}</NavLink>,
              '21',
              <LineChartOutlined />
            )
          ],
          isAdmin && [
            getItem(
              <NavLink to={Urls.RequestLogs}>{t('Request log')}</NavLink>,
              '22',
              <FileSearchOutlined />
            )
          ]
        ].flat()}
        mode="inline"
        selectedKeys={[selectedKey.toString()]}
        theme="dark"
      />
    </Sider>
  );
};
